import Alert from '@mui/material/Alert';
import { Collapse } from 'react-bootstrap';

export default function ModalErrorMessage({ message, setShow }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setShow(false);
  };

  return (
    <Collapse in={!!message} sx={{ mt: 1, mb: 1 }}>
      <Alert severity="error" onClose={handleClose}>
        {message}
      </Alert>
    </Collapse>
  );
}
